import { TenantReducer } from './TenantReducer';
import ThemeOptions from './ThemeOptions';
import { IssuerCompanyReducer } from './IssuerCompanyReducer';

export default {
  ThemeOptions,
  TenantReducer,
  IssuerCompanyReducer,
};
